import { useMemo } from "react"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import SearchFormContainer from "Components/atoms/containers/search-form-container"
import SearchSelect from "Components/molecule/inputs/search-select"
import TextInput from "Components/molecule/inputs/text-input"
import { SelectOption } from "Components/molecule/inputs/select-input"
import { IUserQueryParams } from "models/user"
import useEnterSearch from "hooks/useEnterSearch"

interface SearchUserFormProps {
    handleChangeQuery: (key: keyof IUserQueryParams, value: any) => any,
    handleClearSearch: () => any,
    handleSearch: () => any,
    roles: SelectOption[],
    userStatuses: SelectOption[],
    query: IUserQueryParams
    isSearching: boolean
}

const SearchUserForm = ({
    handleChangeQuery,
    handleClearSearch,
    handleSearch,
    roles,
    userStatuses,
    query,
    isSearching
}: SearchUserFormProps) => {

    const { inputProps, selectProps } = useEnterSearch(handleSearch)

    const roleValue = useMemo(() => query.roleIds?.[0] ?? '', [query])
    const statusValue = useMemo(() => query.userStatusIds?.[0] ?? '', [query])

    return (
        <SearchFormContainer
            inputs={
                <>
                    <TextInput
                        label="Email"
                        value={query.email ?? ""}
                        onChange={(e) => handleChangeQuery("email", e?.target.value ?? "")}
                        placeholder="e.g. name@ramconsulting.com"
                        {...inputProps}
                    />

                    <SearchSelect
                        label="Role"
                        options={roles}
                        value={roleValue}
                        onChange={(e) => handleChangeQuery('roleIds', e?.value ? [e.value] : undefined)}
                        {...selectProps}
                    />

                    <SearchSelect
                        label="Status"
                        options={userStatuses}
                        value={statusValue}
                        onChange={(e) => handleChangeQuery('userStatusIds', e?.value ? [e.value] : undefined)}
                        {...selectProps}
                    />
                </>
            }
            clearSearchButton={
                <>
                    <PrimaryButton
                        style={{
                            minWidth: '150px'
                        }}
                        disabled={isSearching}
                        onClick={handleSearch}
                    >
                        {isSearching ? 'Searching...' : 'Search'}
                    </PrimaryButton>
                    <SecondaryButton
                        style={{
                            minWidth: '100px'
                        }}
                        disabled={isSearching}
                        onClick={handleClearSearch}
                    >
                        Clear Search
                    </SecondaryButton>
                </>
            }
        />
    )
}

export default SearchUserForm
